/** Clinic feature configuration API client (ADR-0027): exam mode + prescribing. */
import { apiClient } from "./client";

export interface ClinicFeatures {
  /** Khám dịch vụ is always on; this toggles Khám BHYT. */
  bhytEnabled: boolean;
  /** Kê toa & Thuốc */
  prescribeEnabled: boolean;
  manageInventory: boolean;
  allowSelling: boolean;
  showPriceOnRx: boolean;
  deductStockOnDispense: boolean;
}

export const clinicFeaturesApi = {
  get(): Promise<ClinicFeatures> {
    return apiClient.get<ClinicFeatures>("/v1/clinic/features").then((r) => r.data);
  },
  update(req: ClinicFeatures): Promise<ClinicFeatures> {
    return apiClient.put<ClinicFeatures>("/v1/clinic/features", req).then((r) => r.data);
  },
};

export const clinicFeaturesQueryKeys = {
  current: () => ["clinic", "features"] as const,
};
